import React, { useEffect, useState } from 'react';

interface GridOverlayProps {
  parallaxOffset?: { x: number; y: number };
}

export const GridOverlay: React.FC<GridOverlayProps> = ({ parallaxOffset = { x: 0, y: 0 } }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Fade in after component mounts
    const timer = setTimeout(() => setIsLoaded(true), 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div 
      className="absolute inset-0 overflow-hidden pointer-events-none transition-opacity duration-1000"
      style={{
        opacity: isLoaded ? 1 : 0,
        transform: `translate(${parallaxOffset.x * 8}px, ${parallaxOffset.y * 6}px)`,
        transition: 'transform 0.3s ease-out, opacity 1s ease-out',
      }}
    >
      {/* Grid pattern */}
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `
            linear-gradient(to right, rgba(255, 255, 255, 0.02) 1px, transparent 1px),
            linear-gradient(to bottom, rgba(255, 255, 255, 0.02) 1px, transparent 1px)
          `,
          backgroundSize: '80px 80px',
        }}
      />
      
      {/* Gradient fade on edges */}
      <div
        className="absolute inset-0"
        style={{
          background: `
            radial-gradient(ellipse at center, transparent 20%, rgba(10, 10, 10, 0.3) 60%, rgba(10, 10, 10, 1) 100%)
          `,
        }}
      />
    </div>
  );
};
